/* Common Imports */

import React from "react";

/* Component Imports */

import Layout from "../components/layout-components/Layout";
import ContactUs from "../components/page-sections/index/ContactUs";
import SectionOne from "../components/page-sections/IndexNew/SectionOne";
/* Session Imports */

import { withIronSessionSsr } from "iron-session/next";
import AboutUs from "../components/page-sections/IndexNew/AboutUs";
import OriginSection from "../components/page-sections/IndexNew/OriginSection";
import Projects from "../components/page-sections/IndexNew/Projects";
import StaticPropertyImage from "../components/page-sections/IndexNew/StaticPropertyImage";
import { sessionOptions } from "../lib/session";

const Index = ({ user }) => {
  return (
    <React.Fragment>
      <Layout
        backgroundPlaceholder={false}
        noContainer
        user={user}
        title="Sustainable Eco-Friendly Homes In Bengaluru | Sentient Developers"
        description="Discover sustainable, eco-friendly homes by sentient developers. Enjoy green living with modern design, energy savings, and premium comfort in Bengaluru."
      >
        {/* <PropertyImage /> */}
        <StaticPropertyImage/>
        <SectionOne />
        <Projects />
        <AboutUs />
        <OriginSection />
        <ContactUs />
      </Layout>
    </React.Fragment>
  );
};

export default Index;

// eslint-disable-next-line space-before-function-paren
export const getServerSideProps = withIronSessionSsr(async function ({ req, res }) {
  /* Getting user session cookie */
  const user = await req.session.user;

  /* User Authorization */
  if (user == undefined) {
    return {
      props: {
        user: { isLoggedIn: false },
      },
    };
  } else {
    /* Pass data to the page via props */
    return {
      props: { user: req.session.user },
    };
  }
}, sessionOptions);
